var render = function render(_c,_vm){return _c('div',_vm._g({staticClass:"dropdown-items__item"},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }